import PushSettings from "@/components/PushSettings";
import api from "@/lib/api";

export default function NotificationsPage() {
  return (
    <div className="max-w-3xl" data-testid="notifications-page">
      <div className="mb-6">
        <h1 className="text-2xl text-[#0F1829]" style={{ fontFamily: "'Fraunces', serif", fontWeight: 600 }}>
          Notificações
        </h1>
        <p className="text-sm text-[#6B7280] mt-1">
          Gere as notificações push deste dispositivo e escolhe quais alertas queres receber.
        </p>
      </div>
      <PushSettings api={api} scope="crm" />
    </div>
  );
}
